import { render, staticRenderFns } from "./Monthspicker.vue?vue&type=template&id=497481b3&scoped=true"
import script from "./Monthspicker.vue?vue&type=script&lang=js"
export * from "./Monthspicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497481b3",
  null
  
)

export default component.exports